export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_06.a884b502.jpg";